export const blogs = [
  {
    id: "building-for-real-problems",
    title: "Building for real problems before broad markets",
    date: "2026-05-18",
    readingTime: "4 min read",
    href: "/blog/building-for-real-problems"
  },
  {
    id: "gradevit-lessons",
    title: "What GradeVIT taught us about useful student tools",
    date: "2026-05-08",
    readingTime: "5 min read",
    href: "/blog/gradevit-lessons"
  },
  {
    id: "studio-operating-principles",
    title: "The operating principles behind Technie",
    date: "2026-04-24",
    readingTime: "3 min read",
    href: "/blog/studio-operating-principles"
  }
];
